
document.addEventListener('DOMContentLoaded', function() {
    const agePopup = document.querySelector('.banner-section-wrapper');
    const body = document.body;
    if (agePopup) {
        body.style.overflow = 'hidden';
        body.style.height = '100vh';
        agePopup.style.display = "block";
    }
    const acceptBtn = document.querySelector('.popup-banner-block .button--primary');
    const declineBtn = document.querySelector('.popup-banner-block .button--secondary');
    if (acceptBtn) {
        acceptBtn.addEventListener('click', function(e) {
            e.preventDefault();
            agePopup.style.display = '';
            body.style.overflow = '';
            body.style.height = '';
            localStorage.setItem('age_verified', 'true');
        });
    }
    if (declineBtn) {
        declineBtn.addEventListener('click', function(e) {
            e.preventDefault();
            window.location.href = "https://www.google.com";
        });
    }
    if (localStorage.getItem('age_verified') === 'true') {
        agePopup.style.display = 'none';
        body.style.overflow = '';
    }
});